module.exports = __webpack_public_path__ + "static/img/7_v2.23657129.png";